import { z } from 'zod';

export const LOCKBOX_MASK = '●●●●';

export const LockboxGatedFields = z.object({
  lockboxCode: z.string(),
  lockboxGated: z.boolean(),
});
export type LockboxGatedFields = z.infer<typeof LockboxGatedFields>;
